import { render, staticRenderFns } from "./IssuesAndGoals.vue?vue&type=template&id=d6923baa"
import script from "./IssuesAndGoals.vue?vue&type=script&lang=js"
export * from "./IssuesAndGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports